import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const fetchData = () => ({
  type: types.FETCH_DATA,
});

const setActiveTab = (tabKey) => ({
  type: types.SET_ACTIVE_TAB,
  tabKey
});

const { init: initOppCharts, fetching: fetchOppCharts } = createAllActions(types.IMP_OPP_CHARTS);
const { init: initBenchmark, fetching: fetchBenchmark } = createAllActions(types.IMP_BENCHMARK);
const { init: initAdContentTable, fetching: fetchAdContentTable } = createAllActions(types.IMP_OPP_AD_CONTENT);

export {
  fetchData,
  setActiveTab,
  initBenchmark,
  fetchBenchmark,
  initOppCharts,
  fetchOppCharts,
  initAdContentTable,
  fetchAdContentTable,
};
